// @ts-nocheck
/* eslint-disable */

import * as Types from '../../graphql/v5/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLogoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLogoQuery = { __typename?: 'Query', logo: { __typename?: 'LogoImageType', imageWeb: string, title: string } };


export const GetLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageWeb"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;
export function useGetLogoQuery(baseOptions?: Apollo.QueryHookOptions<GetLogoQuery, GetLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogoQuery, GetLogoQueryVariables>(GetLogoDocument, options);
      }
export function useGetLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogoQuery, GetLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogoQuery, GetLogoQueryVariables>(GetLogoDocument, options);
        }
export function useGetLogoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogoQuery, GetLogoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLogoQuery, GetLogoQueryVariables>(GetLogoDocument, options);
        }
export type GetLogoQueryHookResult = ReturnType<typeof useGetLogoQuery>;
export type GetLogoLazyQueryHookResult = ReturnType<typeof useGetLogoLazyQuery>;
export type GetLogoSuspenseQueryHookResult = ReturnType<typeof useGetLogoSuspenseQuery>;